/**
 * @desc  获取登录状态
 * @param {Object} wait - 登入通过传入USERINFO对象，登出USERINFO传入null
 * 同步修改state中的值，使用方法：this.$store.commit('方法名'，value)
 */
export const CHANGE_USER_STATUS = (state, userInfo) => {
  if (userInfo) {
    state.user_info = userInfo
  } else if (userInfo == null) {
    localStorage.setItem('token', '')
    localStorage.setItem('userInfo', null)
    state.user_info = null
    state.isLogin = false
    state.token = ''
  }
}

/**
 * @desc  存储用户的信息
 * @param {Object} wait - 登入时传入
 */
export const SET_USER_INFO = (state, userInfo) => {
  state.user_info = userInfo
}
/**
 * @desc  存储账套id
 * @param {Object} wait - 
 */
export const SET_SUITID = (state, suitid) => {
  state.suitid = suitid
}
/**
 * @desc  登出时移除用户信息
 * @param {Object} wait - 登入时传入
 */
export const REMOTE_USER_INFO = (state) => {
  state.user_info = ""
}

/**
 * @desc  存储 用户标识 token
 * @param {Object} wait - 登入时传入
 */
export const SET_TOKENS = (state, token) => {
  state.token = token
}
/**
 * @desc  移除 用户标识 token
 * @param {Object} wait - 登出时传入
 */
export const REMOVE_TOKENS = (state) => {
  state.token = ""
}
/**
 * @desc  设置 消息数量
 * @param {Object} wait - 设置总消息数量
 */
export const SET_MESSAGE_ACOUNT = (state, count) => {
  state.messages_count = count
}
/**
 * @desc  设置登录状态
 * @param {Object} wait - 设置登录状态
 */
export const SET_LOGIN_STATUS = (state, status) => {
  state.isLogin = status
}
/**
 * @desc  更新 消息数量
 * @param {Object} wait - 单个消息数量减少更新
 */
export const REDUCE_MESSAGE_ACOUNT = (state) => {
  state.messages_count--
}
/**
 * @desc  设置 商户后台 默认打开地址
 * @param {Object} wait - 登出时传入
 */
export const SET_DEFAULT_URL = (state, url) => {
  state.defaultActiveUrl = url
}



// WEBPACK FOOTER //
// ./src/store/mutations.js